import * as React from 'react'

interface IFormLabelProps {
  children: string
  htmlFor?: string
}

const FormLabel = (props: IFormLabelProps) => {
  const { children, htmlFor } = props

  return (
    <label className='font-small bold font-grey3' htmlFor={htmlFor}>
      {children}
    </label>
  )
}

export default FormLabel



// WEBPACK FOOTER //
// ./src/components/ui/form/FormLabel.tsx